'use client';

import {
	BaseMessageSignerWalletAdapter,
	WalletName,
} from '@solana/wallet-adapter-base';
import useDriftStore from '../stores/DriftStore/useDriftStore';
import { singletonHook } from 'react-singleton-hook';

const INITIAL_WALLET_STATE: Pick<
	BaseMessageSignerWalletAdapter,
	| 'connected'
	| 'publicKey'
	| 'disconnect'
	| 'connect'
	| 'signTransaction'
	| 'signMessage'
	| 'name'
> = {
	name: 'blank' as WalletName<'MyCryptoWallet'>,
	connected: false,
	publicKey: null,
	disconnect: async () => {
		console.error('Tried disconnecting from DEFAULT WALLET');
	},
	connect: async () => {
		console.error('Tried connecting with DEFAULT WALLET');
	},
	signTransaction: async (_t) => {
		console.error('Tried signing tx with DEFAULT WALLET');
		return _t;
	},
	signMessage: async (_m) => {
		console.error('Tried signing message with DEFAULT WALLET');
		return _m;
	},
};

const useCurrentWalletAdapter = () => {
	const walletInStore = useDriftStore((s) => s.wallet?.current?.adapter);
	const wallet = walletInStore ?? INITIAL_WALLET_STATE;

	return wallet as BaseMessageSignerWalletAdapter;
};

export default singletonHook(
	INITIAL_WALLET_STATE as BaseMessageSignerWalletAdapter,
	useCurrentWalletAdapter
);
